import script from "./AdminPendingVacancies.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPendingVacancies.vue?vue&type=script&setup=true&lang=js"

import "./AdminPendingVacancies.vue?vue&type=style&index=0&id=2b6e50c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b6e50c7"]])

export default __exports__